export default {"src":"/_next/static/media/GamCare.f2ece211.svg","height":40,"width":128,"blurWidth":0,"blurHeight":0};